import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import qs from "qs";
import { API_BASE } from "utils/api";

const fetchTransactions = (endpoint) => async ({ queryKey }) => {
  const [, , filters] = queryKey;
  const { data } = await axios.get(`${API_BASE}/purchase/${endpoint}`, {
    params: filters,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return data;
};

export const useSuspiciousTransactions = (filters, enabled) =>
  useQuery({
    queryKey: ["transactions", "suspicious", filters],
    queryFn: fetchTransactions("suspicious_transactions"),
    enabled,
  });

export const useVoidTransactions = (filters, enabled) =>
  useQuery({
    queryKey: ["transactions", "void", filters],
    queryFn: fetchTransactions("void_transactions"),
    enabled,
  });

export const useUpdateTransaction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ row, status, comment }) =>
      axios.post(`${API_BASE}/purchase/update_suspicious_transactions/`, {
        row,
        status,
        comment,
      }),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["transactions"] }),
  });
};
